import React from 'react';
import { colors } from '../../lib/colors';

interface LogoProps {
    className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = '' }) => {
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <div
                className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-lg shadow-sm"
                style={{
                    background: `linear-gradient(135deg, ${colors.brand.primary} 0%, ${colors.brand.accent} 100%)`
                }}
            >
                P
            </div>
            <span className="text-lg font-bold text-gray-900">PCM Portal</span>
        </div>
    );
};
